// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Earth Draw",
  id: "earth-draw",
  metadata: {
    aspect: SavedSpellAspect.Earth,
    imports: ["earth"],
    icon: {
      "backgroundColor": 2430986,
      "layers": [
        {
          "iconKey": "earthSpike",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -17,
          "color": 12163418
        }
      ]
    },
  },
};

export default metadata;
